var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { keyof } from "@haipham/javascript-helper-object";
import { t } from "@swissknife/sdk";
export var PIPE_RECIPES_BY_TYPE = {
    "create-simple-clock": {
        name: t("Create a simple clock"),
        description: t("Create a simple clock that ticks every one second"),
        pipeFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, [
                        {
                            pipeType: "stream-interval",
                            additionalArgs: { intervalMs: 1000 },
                        },
                        { pipeType: "get-current-date" },
                        {
                            pipeType: "date-to-string",
                            additionalArgs: { format: "DD/MM/YYYY hh:mm:ss A" },
                        },
                    ]];
            });
        }); },
    },
    "compare-documents-and-visualize-diffs": {
        name: t("Compare documents and visualize diffs"),
        description: t([
            "Compare two documents and produce a HTML representation of the ",
            "differences, which can then be visually previewed",
        ].join("")),
        pipeFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, [
                        {
                            pipeType: "compare-documents",
                            additionalArgs: {
                                documentToCompare: t("Type some texts into the big input box to compare against this text"),
                                showOnlyDiff: false,
                            },
                        },
                        { pipeType: "document-diffs-to-html" },
                    ]];
            });
        }); },
    },
    "compare-documents-by-sentences-and-visualize-diffs": {
        name: t("Compare documents by sentences and visualize diffs"),
        description: t([
            "Compare two documents by sentences and produce a HTML representation ",
            "of the differences, which can then be visually previewed. Performance ",
            "is not as good as ".concat(keyof("compare-documents-and-visualize-diffs"), "."),
        ].join("")),
        pipeFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, [
                        {
                            pipeType: "compare-documents-by-sentences",
                            additionalArgs: {
                                documentToCompare: t("Type some texts into the big input box to compare against this text"),
                                showOnlyDiff: false,
                            },
                        },
                        {
                            pipeType: "document-diffs-to-html",
                        },
                    ]];
            });
        }); },
    },
    "find-10-most-frequently-used-words": {
        name: t("Find 10 most frequently used words"),
        description: t("Find 10 most frequently used words in a document"),
        pipeFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, [
                        { pipeType: "count-word-frequency" },
                        {
                            pipeType: "sort-word-frequency",
                            additionalArgs: { order: "descending" },
                        },
                        {
                            pipeType: "get-first-n-array-elements",
                            additionalArgs: { numberOfElements: 10 },
                        },
                    ]];
            });
        }); },
    },
};
export var PIPE_RECIPES = Object.entries(PIPE_RECIPES_BY_TYPE).map(function (_a) {
    var _b = __read(_a, 2), recipeType = _b[0], recipe = _b[1];
    return __assign(__assign({}, recipe), { type: recipeType });
});
